import { render, staticRenderFns } from "./tabs-horizontal.vue?vue&type=template&id=894d1fe0"
import script from "./tabs-horizontal.vue?vue&type=script&lang=js"
export * from "./tabs-horizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports